import { useRef, useCallback, useEffect } from "react";
import { ReactFlowInstance } from "reactflow";

// Hook for managing refs and instance state
export const useRefsAndInstance = () => {
  const initMessageLogged = useRef(false);
  const mountedRef = useRef(false);
  const initializationRef = useRef(false);
  const initializationRecorded = useRef(false);
  const reactFlowInstance = useRef<ReactFlowInstance | null>(null);
  const resizeTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const onInit = useCallback((instance: ReactFlowInstance) => {
    if (initializationRef.current || initializationRecorded.current) {
      return;
    }
    
    reactFlowInstance.current = instance;
    initializationRef.current = true;
    initializationRecorded.current = true;
  }, []);

  useEffect(() => {
    mountedRef.current = true;
    
    return () => {
      mountedRef.current = false;
      initializationRef.current = false;
      initializationRecorded.current = false;
    };
  }, []);

  return {
    initMessageLogged,
    mountedRef,
    initializationRef,
    initializationRecorded,
    reactFlowInstance,
    resizeTimeoutRef,
    onInit,
  };
};